import { NgModule } from '@angular/core';

import { IntegracaoRoutingModule } from './integracao-routing.module';

import { DatePipe } from '@angular/common';
import { SCRImportacaoComponent } from './scr/scr-importacao.component';
import { ScrListagemComponent } from './scr-pesquisa/scr-listagem/scr-listagem.component';
import { ScrPesquisaComponent } from './scr-pesquisa/scr-pesquisa.component';
import { ScrAssociadosPesquisaComponent } from './scr-associados/scr-associados-pesquisa.component';
import { ScrAssociadosListagemComponent } from './scr-associados/scr-associados-listagem/scr-associados-listagem.component';
import { ScrControleComponent } from './scr-controle/scr-controle.component';
import { IpocPesquisaComponent } from './scr-ipoc/ipoc-pesquisa.component';
import { IpocEnvioComponent } from './scr-ipoc/ipoc-envio.component';
import { IpocCadastroComponent } from './scr-ipoc/ipoc-cadastro.component';
import { SharedModule } from "../../shared/shared.module";
import { ModalCadastroScrAssociados } from './scr-associados/modal-cadastro-scr-associados/modal-cadastro-scr-associados.component';



@NgModule({
    imports: [
      SharedModule
    ],
    declarations: [
        SCRImportacaoComponent,
        ScrListagemComponent,
        ScrPesquisaComponent,
        ScrAssociadosPesquisaComponent,
        ModalCadastroScrAssociados,
        ScrAssociadosListagemComponent,
        ScrControleComponent,
        IpocPesquisaComponent,
        IpocEnvioComponent,
        IpocCadastroComponent,
    ],
    exports: [
        IntegracaoRoutingModule
    ],
    providers: [
        DatePipe,
    ]
})
export class IntegracaoModule { }
